// extracted by mini-css-extract-plugin
module.exports = {"content_footer":"footeraction_content_footer__2XI8R","candidate":"footeraction_candidate__roEpv","name":"footeraction_name__2hPuR","date":"footeraction_date__3FvOT"};